export default __webpack_public_path__ + "static/media/cross.256267f4.svg";